import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileSize',
  standalone: true
})
export class FileSizePipe implements PipeTransform {

  // transform(value: number): string {
  //   if (!value) return '0 MB';
  //   const megabytes = value / (1024 * 1024);
  //   return `${megabytes.toFixed(2)} MB`;
  // }

  transform(value: number): string {
    if (!value) return '0 Bytes'; // Default to 0 B (bytes)

    if (value < 1024) {
      // If less than 1 KB, show in bytes
      return `${value} Bytes`;
    } else if (value < 1024 * 1024) {
      // If less than 1 MB, show in KB
      return `${(value / 1024).toFixed(2)} KB`;
    } else if (value < 1024 * 1024 * 1024) {
      // If less than 1 GB, show in MB
      return `${(value / (1024 * 1024)).toFixed(2)} MB`;
    } else {
      // Otherwise, show in GB
      return `${(value / (1024 * 1024 * 1024)).toFixed(2)} GB`;
    }
  }

}
